module.exports = __webpack_public_path__ + "static/media/courses-icon-active.0f0ffaca.svg";